<style lang="scss" scoped>
.footer {
	@include container;

	margin-top: 30px;
	margin-bottom: 50px;

	&__inside {
		padding-top: 20px;
		border-top: 1px solid #e1e1e1;
		text-align: center;

		* {
			margin-bottom: 20px;
		}

		@include sm-and-up {
			@include flex-center;

			text-align: left;
		}

		a {
			margin-left: auto;
			display: block;
		}
	}
}
</style>

<template lang="pug">
    .footer
        .footer__inside
            .footer__text Copyright © {{ year }} Wonde Ltd. All rights reserved.
            a(href="https://www.wonde.com/privacy", target="_blank") Privacy Notice
</template>

<script>
export default {
	data() {
		return {
			year: (new Date()).getFullYear()
		}
	}
};
</script>
